import {Component, Input, OnInit} from '@angular/core';
import { ContactService } from '../../services/contact.service';
import { Router } from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {PropertyByNamePipe} from '../../pipes/property-by-name';

@Component({
  selector: 'app-detail-description',
  templateUrl: './detail-description.component.html'
})
export class DetailDescriptionComponent implements OnInit {

  @Input() item;

  private data;

  private description = null;
  private properties;

  constructor(private router: Router, private contactService: ContactService,
              private translate: TranslateService, private propertyByName: PropertyByNamePipe) { }

  ngOnInit() {
    // this.setElementHeight();
    // console.log(this.data);
    this.data = JSON.parse(this.item.json);

    const descriptionGerman = this.propertyByName.transform(this.data.properties, 'Verkaufsinformationen');
    const descriptionEnglish = this.propertyByName.transform(this.data.properties, 'Sales information');

    if (this.translate.currentLang === 'en') {
      if (descriptionEnglish && descriptionEnglish !== '') {
        this.description = descriptionEnglish;
      }
      this.properties = this.data.propertiesEN;
    }

    if (this.translate.currentLang === 'de') {
      if (descriptionGerman && descriptionGerman !== '') {
        this.description = descriptionGerman;
      }
      this.properties = this.data.properties;
    }


  }

  public setElementHeight() {
    if (document.getElementsByTagName('body')[0].clientWidth < 767) {
      document.getElementsByClassName('description-teaser')[1].setAttribute('style', 'height: auto;');
    } else {
      const teaserHeight = document.getElementsByClassName('description-teaser')[0].clientHeight;
      document.getElementsByClassName('description-teaser')[1].setAttribute('style', 'height:' + teaserHeight + 'px;');
    }
  }

  onResize(event) {
    // console.log('resized');
    // this.setElementHeight();
  }

  requestItem() {
    this.contactService.item = this.item;
    this.router.navigate(['/contact/item', this.item.id]).then();
  }

}
